(function($){

	var anchorLinks = function(){
		
		$('.service-nav-menu a, .case-services a').on('click', function(e){
			
			if(this.hash){
				/*var headerHeight = 0;
				$('.menu-item-has-children').removeClass('hover');
				setTimeout(function(){
					headerHeight = $('.site-header').outerHeight();
				}, 500);*/
				$('body').removeClass('nav-open');
				
				var hashTarget = $(this.hash);
				//console.log(this.hash);
				if( hashTarget.length ){
					e.preventDefault();
					var anchorPosition = hashTarget.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 50;
					$("html, body").animate({scrollTop: finalPosition}, 250);
					$('body').removeClass('nav-open');
				}
			}
		});
		
		if(window.location.hash != ""){
			var winhash = window.location.hash;
			//console.log(winhash);
			var hashTarget = $(winhash);
			
			if( hashTarget.length ){
				var anchorPosition = hashTarget.offset().top;
				var finalPosition = anchorPosition - $('.site-header').outerHeight() - 50;
				$("html, body").animate({scrollTop: finalPosition}, 250);
				$('body').removeClass('nav-open');
			}
		}
	};

	var stickyPosts = function(){
		$('.sticky-posts').slick({
			dots: false,
			arrows: true,
			asNavFor: '.sticky-posts-bg-slider',
			adaptiveHeight: true
		});
		$('.sticky-posts-bg-slider').slick({
			dots: false,
			arrows: false,
			fade: true
		});
		
	};
	
	var caseStudy = function(){
		
		$('.case-gallery-slider').slick({
			dots: false,
			arrows: true,
			centerMode: true,
			centerPadding: 0,
			//adaptiveHeight: true,
			slidesToShow: 3
			
		});
		
		$('.other-projects-slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 3,
			responsive: [
				{
					breakpoint: 639,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}
			]
			
		});
	};
	
	var homeServices = function(){
		//var servicesContainer = $('#home-services');
		var serviceSections = $('.home-service-section');
		
		$('[data-action="service-open"]').on('click', function(e){
			var target = $(this).attr('data-target');
			var servicesContainer = $(this).attr('data-container');
			$(target).addClass('active');
			$(servicesContainer).addClass('open');
		});
		
		$('[data-action="service-close"]').on('click', function(e){
			var servicesContainer = $(this).attr('data-container');
			$(servicesContainer).removeClass('open');
			
			if($(this).hasClass('remove-active')){
				serviceSections.removeClass('active');
			}
		});
		
		$('[data-action="service-switch"]').on('click', function(e){
			var target = $(this).attr('data-target');
			$(target).addClass('active');
			serviceSections.not(target).removeClass('active');
		});
	};
	
	var homeProjects = function(){
		var featuredProjectNav = $('.featured-projects-nav');
		var tabLink = $('[data-action="home-project-tab"]');
		var tabSection = $('.featured-projects-list').find('li');
		
		tabLink.on('click', function(e){
			e.preventDefault();
			var target = this.hash;
			
			tabLink.not($(this)).removeClass('active');
			$(this).addClass('active');
			
			tabSection.not($(target)).removeClass('active');
			$(target).addClass('active');
		});
	};
	
	var homeVideo = function(){
		//var vid = document.getElementById('home-video');
		bgVideoSize('#home-video-container');
		
		var popupVideo = document.getElementById('popup-video');
		$('[data-action="popup-video"]').magnificPopup({
			type:'inline',
			showCloseBtn: true,
			callbacks: {
				open: function() {
					popupVideo.play();
				},
				close: function() {
					popupVideo.pause();
					popupVideo.currentTime = 0;
				}
			}
		});
	};
	
	var bgVideoSize = function(videoContainerSelector){
		var videoContainer = $(videoContainerSelector);
		var videoContainerRatio = videoContainer.outerHeight() / videoContainer.outerWidth();
		var vidObj = videoContainer.find('video');
		var vidEl = document.getElementById(vidObj.attr('id'));
		var vidRatio = vidEl.videoHeight / vidEl.videoWidth;
		
		if(isNaN(vidRatio) || vidRatio == 0){
			vidRatio = 0.5625;
		}
		
		var videoResize = function(){
			
			videoContainerRatio = videoContainer.outerHeight() / videoContainer.outerWidth();
			
			vidRatio = vidEl.videoHeight / vidEl.videoWidth;
	
			if(isNaN(vidRatio) || vidRatio == 0){
				vidRatio = 0.5625;
			}
			
			if( videoContainerRatio <= vidRatio){
				vidObj.removeClass('tall');
				vidObj.addClass('wide');
			}
			else{
				vidObj.removeClass('wide');
				vidObj.addClass('tall');
			}
		};
		
		videoResize();
		optimizedResize.add( videoResize );
		
	};
	
	var staffPageMinHeight = function(){
		var asideHeight = $('.msw-page-header').outerHeight();
		$('.staff_module.hentry').css('min-height', asideHeight);
	};

	$(document).ready(function(){
		anchorLinks();
		stickyPosts();
		caseStudy();
		
		if($('body').hasClass('home')){
			homeServices();
			homeProjects();
			homeVideo();
		}
		
		if($('body').hasClass('single-staff_module')){
			staffPageMinHeight();
			optimizedResize.add(staffPageMinHeight);
		}
		
		
		$("#loginform").submit(function(){
			var isFormValid = true;
			$("input").each(function(){
				if ($.trim($(this).val()).length == 0){
					$(this).addClass("submit_error");
					isFormValid = false;
				}
				else {
					$(this).removeClass("submit_error");
				}
			});
			return isFormValid;
		});
	});

})(jQuery);